import { render, staticRenderFns } from "./PremiumLounge.vue?vue&type=template&id=065617af&scoped=true"
import script from "./PremiumLounge.vue?vue&type=script&lang=js"
export * from "./PremiumLounge.vue?vue&type=script&lang=js"
import style0 from "./PremiumLounge.vue?vue&type=style&index=0&id=065617af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065617af",
  null
  
)

export default component.exports